<template>
  <div class="main container">
    <div class="title-header">
      <div class="row title-container">
        <div class="col-auto">
          <div class="title-header-text">{{ CONSTANTS.ENTERPRISE_SERVICE_DIRECTORY }}</div>
        </div>
        <div class="col-auto px-0">
          <employee-hub-bookmark
            :title="CONSTANTS.ENTERPRISE_SERVICE_DIRECTORY"
            show-circle
            :key="$route.fullPath"
            class="d-inline-block eh-bookmark"
          ></employee-hub-bookmark>
        </div>
      </div>
    </div>

    <loading-overlay v-if="loadingServiceDirectories"></loading-overlay>
    <div class="row enterprise-services-panel">
      <div
        class="col-12 col-lg-3 service-directory-container service-directory-categories-container"
      >
        <service-directory-categories
          :selectedDirectory="selectedDirectory"
          @handleClickServiceDirectory="handleClickServiceDirectory"
        />
      </div>
      <div class="col-12 col-lg-9 services-panel">
        <enterprise-service-directory-platform
          v-if="!loadingServiceDirectories"
          v-for="(servicePlatform, index) in servicePlatforms"
          :key="index"
          :name="servicePlatform.name"
          :serviceAreas="servicePlatform.serviceAreas"
          @handleClickServiceModal="handleClickServiceModal"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { safeImportComponent } from "@/utils/componentImportUtils";
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import LoadingOverlay from "@/components/LoadingOverlay";
import * as CONSTANTS from "@/store/constants";
import router from "@/router";
import EnterpriseServiceModal from "@/components/enterprise-service-directory/EnterpriseServiceModal";
import ToggleButton from "vue-js-toggle-button";
import Vue from "vue";
import EnterpriseServiceDirectoryPlatform from "./EnterpriseServiceDirectoryPlatform";
import ServiceDirectoryCategories from "./ServiceDirectoryCategories";
Vue.use(ToggleButton);

export default {
  name: "enterprise-service-directory",
  components: {
    LoadingOverlay,
    EnterpriseServiceModal,
    EnterpriseServiceDirectoryPlatform,
    ServiceDirectoryCategories
  },
  data() {
    return {
      CONSTANTS,
      selectedDirectory: ""
    };
  },
  computed: {
    ...mapGetters([
      "loadingServiceDirectories",
      "serviceDirectoryTaxonomny",
      "hrTaxonomy",
      "relatedServiceDirectoryTaxonomny",
      "allServiceDirectoryTaxonomny",
      "relatedServiceAreaDirectories",
      "serviceDirectoryCategories"
    ]),
    servicePlatforms() {
      let platforms = [];
      let serviceDirectoryPlatforms = [];
      this.setLoadingServiceDirectories(true);

      if (
        this.serviceDirectoryTaxonomny !== undefined &&
        this.serviceDirectoryTaxonomny.length != 0
      ) {
        this.serviceDirectoryTaxonomny.forEach(serviceArea => {
          let directoryServiceAreas = [];
          let directoryBusinessServiceAreas = [];
          let services = [];
          serviceArea.serviceLines.forEach(serviceLine => {
            services = serviceLine.services.sort(
              this.sortServiceHierarchyItems
            );
            directoryServiceAreas.push({
              name: serviceLine.name,
              services
            });
          });
          let serviceDirectoryPlatform = {
            name: serviceArea.name,
            serviceAreas: directoryServiceAreas
          };
          serviceDirectoryPlatforms.push(serviceDirectoryPlatform);
        });
        this.setLoadingServiceDirectories(false);
      } else {
        this.setLoadingServiceDirectories(true);
      }

      let sortedServiceDirectoryPlatforms = serviceDirectoryPlatforms.sort(
        (a, b) => (a.name > b.name ? 1 : -1)
      );
      return sortedServiceDirectoryPlatforms;
    }
  },
  created() {
    this.setLoadingServiceDirectories(true);
    this.onInitialLoading();
    safeImportComponent(HH_COMPONENTS_URL + "/helphubservice.umd.min.js");
    this.selectedDirectory = this.$route.params.serviceDirectory
      ? this.$route.params.serviceDirectory
      : CONSTANTS.ALL_SERVICE_DIRECTORY;
    if (
      this.selectedDirectory &&
      this.$route.params.id &&
      this.$route.meta.isDirectRequest
    ) {
      this.openServiceDirectoryModal();
    } else {
      this.retrieveServiceDirectoryTaxonomy();
    }
  },

  methods: {
    ...mapMutations([
      "setLoadingServiceDirectories",
      "setServiceDirectoryTaxonomny"
    ]),
    ...mapActions([
      "fetchServiceDirectoryTaxonomy",
      "fetchAllServiceDirectoriesTaxonomy",
      "fetchHRServiceDirectoryTaxonomy",
      "fetchRelatedServiceDirectoriesTaxonomy",
      "fetchRelatedServiceDirectories"
    ]),
    retrieveServiceDirectoryTaxonomy() {
      switch (this.selectedDirectory) {
        case CONSTANTS.HR_PLATFORM:
          this.retrieveHRDirectoryTaxonomy();
          break;
        case CONSTANTS.ALL_SERVICE_DIRECTORY:
          this.retrieveAllDirectoriesTaxonomy();
          break;
        default:
          this.retrieveDirectoryTaxonomy();
      }
    },
    async onInitialLoading() {
      if (
        this.serviceDirectoryCategories === undefined ||
        this.serviceDirectoryCategories.length == 0
      ) {
        await this.fetchRelatedServiceDirectories();
      }
    },
    retrieveHRDirectoryTaxonomy() {
      if (this.hrTaxonomy === undefined || this.hrTaxonomy.length == 0) {
        this.fetchHRServiceDirectoryTaxonomy().then(response => {
          this.setServiceDirectoryTaxonomny(response);
        });
      } else {
        this.setServiceDirectoryTaxonomny(this.hrTaxonomy);
        this.setLoadingServiceDirectories(false);
      }
    },
    async retrieveAllDirectoriesTaxonomy() {
      if (
        this.allServiceDirectoryTaxonomny === undefined ||
        this.allServiceDirectoryTaxonomny.length == 0
      ) {
        let allDirectoriesTaxonomny = [];
        var relatedDirectoryObject = {
          directory: CONSTANTS.SALES_DIRECTORY,
          isAllDirectoriesRequest: true
        };
        await this.fetchHRServiceDirectoryTaxonomy();
        await this.fetchRelatedServiceDirectories();
        await this.fetchRelatedServiceDirectoriesTaxonomy(
          relatedDirectoryObject
        );
        if (this.hrTaxonomy != undefined && this.hrTaxonomy.length != 0) {
          allDirectoriesTaxonomny.push.apply(
            allDirectoriesTaxonomny,
            this.hrTaxonomy
          );
        }
        if (
          this.relatedServiceDirectoryTaxonomny != undefined &&
          this.relatedServiceDirectoryTaxonomny.length != 0
        ) {
          allDirectoriesTaxonomny.push.apply(
            allDirectoriesTaxonomny,
            this.relatedServiceDirectoryTaxonomny
          );
        }
        await this.fetchAllServiceDirectoriesTaxonomy(allDirectoriesTaxonomny);
      } else {
        this.setServiceDirectoryTaxonomny(this.allServiceDirectoryTaxonomny);
        this.setLoadingServiceDirectories(false);
      }
    },
    async retrieveDirectoryTaxonomy() {
      if (Object.keys(this.relatedServiceAreaDirectories).length === 0) {
        await this.fetchRelatedServiceDirectories();
      }
      if (this.selectedDirectory in this.relatedServiceAreaDirectories) {
        this.retrieveRelatedDirectoriesTaxonomy();
      } else {
        this.fetchServiceDirectoryTaxonomy(this.selectedDirectory).catch(() => {
          this.$router.push({ name: "page-not-found" });
        });
      }
    },
    retrieveRelatedDirectoriesTaxonomy() {
      var serviceAreaDirectories = this.relatedServiceAreaDirectories[
        this.selectedDirectory
      ];
      if (
        serviceAreaDirectories != undefined ||
        serviceAreaDirectories.length != 0
      ) {
        var relatedDirectoryObject = {
          directory: this.selectedDirectory,
          isAllDirectoriesRequest: false
        };
        this.fetchRelatedServiceDirectoriesTaxonomy(
          relatedDirectoryObject
        ).catch(() => {
          this.$router.push({ name: "error" });
        });
      }
    },
    openServiceDirectoryModal() {
      this.retrieveServiceDirectoryTaxonomy();
      this.openServiceModal(this.selectedDirectory, this.$route.params.id);
    },
    handleClickServiceModal(serviceObject) {
      if (serviceObject.serviceAreaName == CONSTANTS.HR_SERVICES_AREA) {
        this.openServiceModal(CONSTANTS.HR_PLATFORM, serviceObject.service.id);
      } else {
        this.openServiceModal(this.selectedDirectory, serviceObject.service.id);
      }
      this.$hhMixpanel.trackEvent("Page Hit: " + serviceObject.service.name);
    },
    handleClickServiceDirectory(directory) {
      this.$router.push({
        name: "enterprise-service-directory-page",
        params: { serviceDirectory: directory }
      });
      this.selectedDirectory = directory;
      this.$hhMixpanel.trackEvent("Directory Hit: " + this.selectedDirectory);
      this.retrieveServiceDirectoryTaxonomy();
    },
    sortServiceHierarchyItems(a, b) {
      if (a && a.name && b && b.name) {
        return a.name.localeCompare(b.name);
      }
    },
    openServiceModal(directory, serviceId) {
      this.$router.push({
        name: "enterprise-service-page-modal",
        params: { serviceDirectory: this.selectedDirectory, id: serviceId }
      });
      this.$modal.show(
        EnterpriseServiceModal,
        {
          directory,
          serviceId
        },
        {
          adaptive: true,
          scrollable: true,
          maxWidth: 1200,
          width: "100%",
          height: "auto",
          top: "100px",
          pivotY: 0.3,
          classes: ["eh-service-modal"]
        },
        {
          "before-close": event => {
            this.$router.push(
              `/enterprise-service-directory/${this.selectedDirectory}`
            );
          }
        }
      );
    }
  }
};
</script>

<style scoped>
.title-container {
  display: flex;
  align-content: center;
  align-items: center;
  height: auto;
}
.main {
  background-color: #ffffff !important;
  overflow: hidden;
}
.service-directory-container {
  max-width: 100%;
  padding-right: 15px;
  margin-left: 15px;
  margin-right: 15px;
}
.services-panel {
  padding: 28px 60px;
  height: auto;
  min-height: 700px;
  margin-top: 31px;
  margin-right: 1.1667%;
}
.enterprise-services-panel{
  border: 1px solid #cccccc;
  height: auto;
  min-height: 700px;
  margin-top: 31px;
  margin-bottom: 31px;
  margin-right: 0.1%;
  margin-left: 0.1%;
  border-radius: 4px;
}

.employeehub-service-container {
  max-width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-left: 15px;
  margin-right: 15px;
  padding-top: 33px;
}

@media (min-width: 768px) {
  .employeehub-service-container {
    /* Approximately col-1 offset */
    margin-right: 9.1667%;
    margin-left: 19.1667%;
  }
}
@media (max-width: 767px) {
  .services-panel {
    padding: 15px 30px;
    margin: 15px 0px;
    margin-right: 9.1667%;
    margin-left: 4%;
  }
  .eh-bookmark {
    margin-top: 20px !important;
  }
  .service-directory-container {
    margin-right: 30%;
    margin-left: 30%;
  }
  .service-directory-categories-container >>> hr {
    border-top: 1px solid #ffffff;
  }
  .categories-options {
    text-align: center;
  }
  .title-header-text {
    font-size: 18px !important;
    padding-top: 22px !important;
  }
}

.title-header-text {
  color: #000000;
  font-size: 38px;
  font-weight: bold;
  line-height: 25px;
  font-family: artifaktElementBold;
}
.title-header {
  height: auto;
  margin: 33px 0;
}
.it-services-panel {
  margin-bottom: 50px;
}
.it-business-panel {
  margin-bottom: 20px;
}

.services-role-toggle span {
  margin: -5px 5px 0 15px;
}
.services-role-toggle span.active {
  color: #0696d7;
}

/* modal ovverrides */

.service-directory-categories-container {
  max-width: 150px;
  font-size: 16px !important;
}

.eh-service-modal {
  border-radius: 0;
}


@media (min-width: 768px) {
  .helphub-app-container {
    margin-right: 9.1667%;
    margin-left: 8%;
  }
}



@media only screen and (min-width: 1024px) and (max-height: 1366px) and (-webkit-min-device-pixel-ratio: 1.5) {
  .helphub-app-container {
    margin-left: 8% !important;
  }
  employee-hub-bookmark >>> .bookmark-icon {
    margin-left: 0px !important;
    margin-top: 9px !important;
  }
}

@media only screen and (min-width: 320px) and (max-height: 568px) and (-webkit-min-device-pixel-ratio: 1.5) {
  .helphub-app-container {
    margin-left: 1% !important;
  }
}

@media only screen and (min-width: 768px) and (max-height: 1024px) and (-webkit-min-device-pixel-ratio: 1.5) {
  .services-panel {
    margin-left: 4% !important;
  }
  employee-hub-bookmark >>> .bookmark-icon {
    margin-left: 0px !important;
    margin-top: 9px !important;
  }
}


@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .service-directory-container {
    margin-right: 50%;
    margin-left: 40%;
  }
  .service-directory-categories-container >>> hr {
    border-top: 1px solid #ffffff;
  }
}


@media only screen and (min-width: 1440px) and (max-height: 900px) and (-webkit-min-device-pixel-ratio: 1.5) {
  .helphub-app-container {
    margin-left: 4.3% !important;
  }
  employee-hub-bookmark >>> .bookmark-icon {
    margin-left: 4px !important;
    margin-top: 12px !important;
    font-size:28px !important;
  }
}


@media(min-width: 300px) and (max-height: 915px) {
  employee-hub-bookmark >>> .bookmark-icon {
    margin-left: -5px !important;
    margin-top: 11px !important;
    font-size:20px !important;
  }
}

@media (min-width: 1025px) {
employee-hub-bookmark >>> .bookmark-icon {
  margin-left: 4px !important;
  margin-top: 9px !important;
}
}

@media only screen and (min-width: 1366px) and (max-height: 768px),
only screen and (min-width: 1280px) and (max-height: 800px){
employee-hub-bookmark >>> .bookmark-icon {
  margin-left: 4px !important;
  margin-top: 11px !important;
  font-size:28px !important;
}
}
</style>



// WEBPACK FOOTER //
// src/components/enterprise-service-directory/EnterpriseServiceDirectory.vue